module.exports = __webpack_public_path__ + "static/media/chrisCardFront.d37eb14e.png";